var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.getters.getAcademyDaysLeft === 0 &&
      // /actualizar-licencia
      _vm.$route.path !== ("/" + (this.$t('rPaths.updatingLicence'))) &&
      // /actualizar-mi-plan
      _vm.$route.path !== ("/" + (this.$t('rPaths.updateMyPlan'))) &&
      _vm.$route.path !== '/login' &&
      _vm.$route.path !== '/logout' &&
      // /gestion/plan-personalizado
      !_vm.$route.path.startsWith(("/" + (_vm.$t('rPaths.billing')) + "/" + (_vm.$t('mEditionMenu.billing.customizedPlan.subject')))))?_c('OrganismLimitDate'):_vm._e(),_c('router-view',{attrs:{"name":"view"}}),_c('OrganismTheAlerts'),_c('OrganismTheModal'),_c('OrganismFloatingButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }